import React from "react";
import Styles from "./ForgetPassword.module.css";
import ErrorContainer from "../../common/ErrorContainer";
import Input from "../../Elements/Input";
import FormButton from "../../Elements/FormButton";
import { useState ,useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgetPassword, forgetPasswordConfirm ,resetLoginState} from "../../../reducers/loginReducer";
import loadingGif from "../../../assets/images/gifs/loading_gif_1.gif";
import { useNavigate } from "react-router-dom";
const Form = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formState, changeFormState] = useState({
    type: "email",
    data: null,
  });

  const [errorState, changeErrorState] = useState({
    error: "",
  });

  let [email,setEmail] = useState('');
  let [confirmCode,setConfirmCode] = useState('');
  let [newPassword,setNewPassword] = useState('');
  let [confirmPassword,setConfirmPassword] = useState('');
  let [pin,setPin] = useState('');

  let forgetPasswordLoading = useSelector(state => state.loginReducer.forgetPasswordLoading);
  let forgetPasswordError = useSelector(state => state.loginReducer.forgetPasswordError);
  let forgetPasswordData = useSelector(state => state.loginReducer.forgetPasswordData);
  let forgetPasswordConfirmData = useSelector(state => state.loginReducer.forgetPasswordConfirmData);
  let forgetPasswordConfirmLoading = useSelector(state => state.loginReducer.forgetPasswordConfirmLoading);
  let forgetPasswordConfirmError = useSelector(state => state.loginReducer.forgetPasswordConfirmError);
  useEffect(() => {
    if (forgetPasswordData && forgetPasswordData.confirm_code) {
      setConfirmCode(forgetPasswordData.confirm_code);
      let emailInput = document.getElementById('userEmail');
      if(emailInput){
        emailInput.value = '';
      }
      changeFormState((oldState) => {
        let temp = { ...oldState };
        temp.type = "password";
        return temp;
      });
    }
  }, [forgetPasswordData]);

  useEffect(() => {
    if(forgetPasswordConfirmData){
      dispatch(resetLoginState());
      navigate('/login',{
        state:{
          message:"Your password has been updated successfully. Please log in again to access your account."
        }
      });
      changeFormState((oldState) => {
        let temp = { ...oldState };
        temp.type = "email";
        return temp;
      });
    }
  }, [forgetPasswordConfirmData]);

  useEffect(() => {
    console.log('confirmerror');
  }, [forgetPasswordError]);

  useEffect(() => {
    changeErrorState((oldState) => {
      let temp = { ...oldState };
      temp.error = forgetPasswordConfirmError;
      return temp;
    });
  }, [forgetPasswordConfirmError]);
  function clearState() {
    if (errorState.error) {
      changeErrorState((oldState) => {
        let temp = { ...oldState };
        temp.error = "";
        return temp;
      });
    }
  }

function proceedToPassword(e){
    if(email){
      dispatch(forgetPassword(email));
  }
  else{
    changeErrorState((oldState) => {
      let temp = { ...oldState };
      temp.error = "Email is required";
      return temp;
    });
  }
}

function resetPassword(){
  if(confirmCode && pin && newPassword && confirmPassword){
    if(newPassword !== confirmPassword){
      changeErrorState((oldState) => {
        let temp = { ...oldState };
        temp.error = "New password and confirm password do not match";
        return temp;
      });
    }else{
      dispatch(forgetPasswordConfirm({code:confirmCode,pin,password:newPassword}));
    }
  }else{
    changeErrorState((oldState) => {
      let temp = { ...oldState };
      temp.error = "Please fill all fields";
      return temp;
    });
  }
}

function renderUi() {
   switch(formState.type){
    case "email":
      return <div className={Styles.form_section}>
      <p className={Styles.form_section_text}>Please enter email associated with your account and we’ll send link to reset your password.</p>
      <div style={{position:'relative',width:'100%'}}>
      <ErrorContainer type="style1" state={errorState} />
    
      </div>
      <Input
        type="text"
        placeholder="Email"
        id="userEmail"
        keyPressHandler={(e) => {
          if (e.key == "Enter") {
            proceedToPassword();
          }
        }}
        handler={(e) => {
          clearState();
          setEmail(e.target.value);
          // changeInputData((oldState) => {
          //   let temp = { ...oldState };
          //   temp.email = e.target.value;
          //   return temp;
          // });
        }}
      />
      <div className={Styles.buttonWrapper}>
      <FormButton
        type="style1"
        handler={() => {
          if(!forgetPasswordLoading){
            proceedToPassword();
          }
     
        }}
      >
        Next
      </FormButton>
      {forgetPasswordLoading ? <img src={loadingGif} alt="loading" style={{position:'absolute',top:'0.8em',right:'-5em',width:'3em',height:'3em'}} /> : null}
      </div>
    </div>
    case "password":
      return <div className={Styles.form_section}>
      <p className={Styles.form_section_text}>Please enter new password for{" "}
      <span style={{color:'var(--black)'}}>{email}</span></p>
      
      <div style={{position:'relative',width:'100%'}}>
      <ErrorContainer type="style1" state={errorState} />
      </div>
      <Input
        type="number"
        placeholder="Code from email"
        id="codeFromEmail"
        handler={(e) => {
          clearState();
          setPin(e.target.value);
          // changeInputData((oldState) => {
          //   let temp = { ...oldState };
          //   temp.email = e.target.value;
          //   return temp;
          // });
        }}
      />
      <Input
        type="text"
        placeholder="New Password"
        id="newPassword"
      
        handler={(e) => {
          setNewPassword(e.target.value);
          clearState();
    
          // changeInputData((oldState) => {
          //   let temp = { ...oldState };
          //   temp.email = e.target.value;
          //   return temp;
          // });
        }}
      />
      <Input
        type="text"
        placeholder="Confirm Password"
        id="confirmPassword"
        keyPressHandler={(e) => {
          if (e.key == "Enter") {

            // proceedToPassword();
          }
        }}
        handler={(e) => {
          setConfirmPassword(e.target.value);
          clearState();
    
          // changeInputData((oldState) => {
          //   let temp = { ...oldState };
          //   temp.email = e.target.value;
          //   return temp;
          // });
        }}
      />
      <div className={Styles.buttonWrapper}>  
      <FormButton
        type="style1"
        handler={() => {
          if(!forgetPasswordConfirmLoading){
            resetPassword();
          }
        }}
      >
        Reset Password
      </FormButton>
      {forgetPasswordConfirmLoading ? <img src={loadingGif} alt="loading" style={{position:'absolute',top:'0.8em',right:'-5em',width:'3em',height:'3em'}} /> : null}
      </div>
    </div>
    break;
   }
  }
  
  
  return <div>{renderUi()}</div>;
};

export default Form;
